import AuthConfig from "./AuthConfig";

export default class AuthService {
	static login(email, password) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify({ email, password });
				let endpoint = AuthConfig.endpointLogin;
				let resp = AuthConfig.APIConnector.post(endpoint, {
					body
				});
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}

	static verifyToken(token) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = AuthConfig.endpointVerifyToken;
				let resp = AuthConfig.APIConnector.get(endpoint);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}

	static logout() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = AuthConfig.endpointLogout;
				let resp = AuthConfig.APIConnector.get(endpoint);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}

	static forgotPassword(userEmail) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					AuthConfig.endpointForgotPassword + "?email=" + userEmail;
				let resp = AuthConfig.APIConnector.get(endpoint);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}

	static reSendEmailConfirm(userEmail) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					AuthConfig.endPointReSendEmailConfirm + "?email=" + userEmail;
				let resp = AuthConfig.APIConnector.get(endpoint);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}

	static confirmPasswordReset(code, password) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify({ password });
				let endpoint = AuthConfig.endpointConfirmPassword + "?token=" + code;
				let resp = AuthConfig.APIConnector.post(endpoint, { body });
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/auth/AuthService.js